/* eslint-disable max-lines */
import { Form, Input, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { PlusButton } from 'src/components/common/PlusButton/PlusButton';
import { SearchPanel } from 'src/components/SearchPanel/SearchPanel';
import {
    SearchPanelFilterForm,
    SearchPanelFilterFormProps,
} from 'src/components/SearchPanel/SearchPanelFilterForm';
import { Env } from 'src/core/Environment';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import { LeadsFilter, LeadsStore } from 'src/stores/LeadsStore/LeadsStore';
import { UserStore } from 'src/stores/UserStore/UserStore';
import styled from 'styled-components';

const store = LeadsStore;

export const LeadsPageHeaderPanel = observer(() => {
    const { t } = useTranslation();

    return (
        <StyledHeaderWrapper>
            {Env.appName === 'bo-portal' ? (
                <SearchPanel
                    store={store}
                    placeholder={t('Page.Leads.Filter.Search.Placeholder')}
                    renderPanel={(props) => <FilterPanel {...props} />}
                />
            ) : (
                <SearchPanel
                    store={store}
                    placeholder={t('Page.Leads.Filter.Search.Placeholder')}
                />
            )}
            {UserStore.can.manage.leads && (
                <Tooltip
                    title={t('Page.Leads.AsideHeader.CreateNewItem.Tooltip', {
                        defaultValue: 'Add new lead',
                    })}
                >
                    <PlusButton
                        onClick={() => {
                            const createLink = EntityLinks.leads.create?.();
                            createLink && Router.navigate(createLink);
                        }}
                    />
                </Tooltip>
            )}
        </StyledHeaderWrapper>
    );
});

const FilterPanel = observer((props: SearchPanelFilterFormProps) => {
    const { t } = useTranslation();

    return (
        <SearchPanelFilterForm
            {...props}
            onFinish={({ ...values }: LeadsFilter) => {
                store.filterCriteria?.applyFilter({
                    ...values,
                });
                store.loadList();
            }}
        >
            <Form.Item
                label={t('Page.Leads.Filter.Legal.Name')}
                name="legalName"
            >
                <StyledInput />
            </Form.Item>
        </SearchPanelFilterForm>
    );
});

const StyledInput = styled(Input)`
    height: 2.7rem;
    border-radius: 0.5rem;
`;

const StyledHeaderWrapper = styled.header`
    position: relative;
    display: grid;
    grid-template-columns: 1fr auto;
`;
